import DefaultCRUD from '../utils'
const resource = `/platform`;

const { get, create } = DefaultCRUD(resource)

export default {
  get,
  create,
}
